import { FC, ReactNode } from 'react';

type HighlightCardItem = {
  icon: ReactNode;
  title: string;
  subtitle: string;
};

type HighlightCardsProps = {
  cards: HighlightCardItem[];
};



const HighlightCards: FC<HighlightCardsProps> = ({ cards }) => {
  return (
    <div className="d-flex flex-wrap gap-3">
      {cards.map((card, index) => (
        <div
          key={index}
          className="d-flex align-items-center gap-3 p-3 bg-white rounded"
          style={{ minWidth: 250, flex: 1, border: '1px solid #E0E2E7', borderRadius: '12px' }}
        >
          <div className="d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
            {card.icon}
          </div>
          <div>
            <div style={{ fontWeight: 500, fontSize: 22, color: '#1F2937' }}>{card.title}</div>
            <div style={{ fontSize: 15, color: '#6B7280' }}>{card.subtitle}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HighlightCards;
